import React, { ReactNode } from "react"
import {
  DioboxEvent, Form, FormType, PreviewSelectOptions,
} from "sharedTypes"
import FormSelection from "./FormSelection"
import DummyForm from "./DummyForm"
import GuestConfirmationPage from "./GuestConfirmationPage"
import PreviewFrameWithBranding from "./PreviewFrameWithBranding/PreviewFrameWithBranding"
import { StyleAndConfigurationModalName } from "../StyleAndConfigurationModals/StyleAndConfigurationModals"

type Props = {
  event: DioboxEvent,
  selectedOption: PreviewSelectOptions
  forms: Form[]
  onSelectModal: (modalName: StyleAndConfigurationModalName | null) => void
}

// Maps each single-form preview option to the form type it previews, so the one form actually
// on screen (as opposed to the event's default) can be threaded into blocks — like Map Link and
// the Guest Confirmation Page — that need to resolve translations the same way guests would.
export const formTypeByOption: Partial<Record<PreviewSelectOptions, FormType>> = {
  [PreviewSelectOptions.RegistrationForm]: FormType.Registration,
  [PreviewSelectOptions.TicketForm]: FormType.Ticket,
  [PreviewSelectOptions.RsvpForm]: FormType.RSVP,
  [PreviewSelectOptions.WaitlistForm]: FormType.Waitlist,
  [PreviewSelectOptions.SurveyForm]: FormType.Survey,
}

const PreviewContent = ({
  event: { portalPrimaryColor },
  event,
  selectedOption,
  forms,
  onSelectModal,
}: Props) => {
  let portalContentToRender: ReactNode = null

  const previewedFormType = formTypeByOption[selectedOption]
  const previewedForm = previewedFormType
    ? forms.find(({ type }) => type === previewedFormType)
    : undefined

  switch (selectedOption) {
    case PreviewSelectOptions.FormSelectionPage:
      portalContentToRender = <FormSelection event={event} forms={forms} />
      break
    case PreviewSelectOptions.GuestConfirmationPage:
      portalContentToRender = (
        <GuestConfirmationPage
          event={event}
          languageTemplateId={previewedForm?.languageTemplateId}
        />
      )
      break
    case PreviewSelectOptions.RegistrationForm:
    case PreviewSelectOptions.TicketForm:
    case PreviewSelectOptions.RsvpForm:
    case PreviewSelectOptions.WaitlistForm:
    case PreviewSelectOptions.SurveyForm:
      portalContentToRender = (
        <DummyForm
          form={previewedForm!}
          portalPrimaryColor={portalPrimaryColor}
        />
      )
      break
    default: {
      break
    }
  }

  return (
    <PreviewFrameWithBranding
      event={event}
      showSectionOverlays
      onSelectModal={onSelectModal}
      languageTemplateId={previewedForm?.languageTemplateId}
    >
      {portalContentToRender}
    </PreviewFrameWithBranding>
  )
}

export default React.memo(PreviewContent)
